<template>
  <section v-if="activePackage" class="row">
    <card>
      <div class="d-flex flex-wrap">
        <div class="col-12 mb-4">
          <div class="row">
            <div class="col-12">
              <h3>Editing {{ activePackage.label }}</h3>
              <button class="btn btn-sm btn-primary" @click="viewAll">View all packages</button>
              <button class="btn btn-sm btn-primary ml-1" @click="savePackage(activePackage)">Save</button>
            </div>
          </div>
        </div>

        <div class="col-12 mb-4">
          <div class="row">
            <div class="col-6">
              Label
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activePackage.label"
                placeholder="i.e. Package Name"
              />
            </div>
            <div class="col-6">
              Wedfeed Label Override 
              <info-box>
                If left blank the webfeed label will be constructed by combining the dwelling name and lot number.<br>
                (e.g. The Dwelling - Lot 332)<br>
                Entering a name in this field will override this.
              </info-box>
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activePackage.webfeedLabelOverride"
                placeholder=""
              />
            </div>
            <div class="col-6">
              Price
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activePackage.price"
                placeholder=""
              />
            </div>
            <div class="col-6">
              Virtual Tour URL
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activePackage.virtualTourUrl"
                placeholder=""
              />
            </div>
          </div>
        </div>
        <div class="col-12 mb-4">
          <div class="row">
            <div class="col-6">
              Associated Property
              <input-single-select
                v-model="activePackage.propertyId"
                :options="propertyOptions"
              />
            </div>
            <div class="col-6">
              Associated Dwelling
              <input-single-select
                v-model="activePackage.dwellingId"
                :options="dwellingOptions"
              />
            </div>
          </div>
        </div>
        <div class="col-12 mb-4">
          <div class="row">
            <div class="col-6">
              Package Overlay Image
              <input-asset
                v-model="activePackage.overlayImage"
                key="overlay-image"
                :multiple="false"
              />
            </div>
          </div>
        </div>
      </div>
    </card>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import InfoBox from '@/components/InfoBox'
import InputAsset from '@/components/InputAsset'
import InputSingleSelect from '@/components/InputSingleSelect'
import InputMultiSelect from '@/components/InputMultiSelect'

export default {
  components: { InfoBox, InputAsset, InputSingleSelect, InputMultiSelect },

  data () {
    return {
      activePackageId: null,
    }
  },

  computed: {
    ...mapGetters([
      'properties',
      'dwellings',
      'packages'
    ]),

    activePackage () {
      return this.packages.find(_package => _package._id === this.activePackageId)
    },

    propertyOptions () {
      let propertyOptions = []
      this.properties.forEach(property => {
        propertyOptions.push({
          label: property.label,
          value: property._id
        })
      })
      return propertyOptions
    },

    dwellingOptions () {
      let dwellingOptions = []
      this.dwellings.forEach(dwelling => {
        dwellingOptions.push({
          label: dwelling.label,
          value: dwelling._id
        })
      })
      return dwellingOptions
    },
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_PACKAGES')
    this.$store.dispatch('FETCH_PROPERTIES')
    this.$store.dispatch('FETCH_DWELLINGS')
  },

  mounted () {
    this.activePackageId = this.$route.params.id
  },

  methods: {
    viewAll () {
      this.$router.push('/live/packages')
    },

    savePackage (_package) {
      if (!_package.propertyId || !_package.dwellingId) {
        alert('Property and Dwelling required')
      } else {
        this.$store.dispatch('SAVE_PACKAGE', _package)
        this.viewAll()
      }
    },
  },
}
</script>
